import { render } from "./Result4D.vue?vue&type=template&id=35784820"
import script from "./Result4D.vue?vue&type=script&lang=js"
export * from "./Result4D.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__